import {useEffect, useState} from "react";
import {createPortal} from "react-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2/dist/sweetalert2.js";

const MySwal = withReactContent(Swal);

export const SweetAlert2 = (props: any) => {
  const [container, setContainer] = useState<any>(null);

  useEffect(() => {
    if (props.show) {
      //@ts-ignore
      MySwal.fire({
        html: <div ref={(el) => setContainer(el)}/>,
        preConfirm: res => props.onAction && props.onAction(res),
        willClose: res => props.onClose && props.onClose(),
        showClass: {
          popup: ""
        },
        hideClass: {
          popup: ""
        },
        ...props
      });
    }
  }, [props.show]);

  if (container) {
    return createPortal(props.children, container);
  }
  return null;
};